/**
 * The non-uniform-scale rule shared by every CollisionObject3D-derived node,
 * reached through `applicableNodeTypeMatcher` and `descendsFromClass`, since
 * `RuleRegistry` matches exact types. It checks the body's own transform
 * (collision_object_3d.cpp:744), not a child's (collision_shape_3d.cpp:155).
 */
import { ruleRegistry } from '../../../linter/RuleRegistry.js';
import { descendsFromClass } from '../../../godot/classdb/classBaseTypes.js';
import { isZeroApprox } from '../../../godot/math/math.js';
import { basisColumnScales } from '../../../linter/physics/basisColumnScales.js';
import { armDiagnostic, armEmits, groundedArm } from '../../../linter/ruleArms.js';
const arms = {
    nonUniformScale: groundedArm('collisionobject3d-non-uniform-scale', { kind: 'configuration-warning' }),
};
function checkCollisionObject3DScale(context) {
    const { node } = context;
    const rawProps = node.rawProperties;
    if (rawProps.transform === undefined)
        return [];
    const scales = basisColumnScales(rawProps.transform);
    if (!scales)
        return [];
    const [sx, sy, sz] = scales;
    if (isZeroApprox(sx - sy) && isZeroApprox(sy - sz))
        return [];
    return [
        armDiagnostic(arms.nonUniformScale, node, `${node.type} '${node.name}' has a non-uniformly scaled transform ` +
            `(${sx.toFixed(3)}, ${sy.toFixed(3)}, ${sz.toFixed(3)}), which will probably not ` +
            'function as expected. Keep its scale uniform and change the size of its collision ' +
            'shapes instead.'),
    ];
}
const collisionObject3DScaleRule = {
    meta: {
        name: 'valid-collisionobject3d-scale',
        description: "Warns when a CollisionObject3D-derived node's own transform is scaled non-uniformly, which the physics engine cannot honour",
        category: 'validation',
        applicableNodeTypeMatcher: (nodeType) => descendsFromClass(nodeType, 'CollisionObject3D'),
        emits: armEmits(arms),
    },
    check: checkCollisionObject3DScale,
};
ruleRegistry.register(collisionObject3DScaleRule);
//# sourceMappingURL=linter.js.map